import { ImpPad, ImpSpinner } from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { callPrompt } from '../../api/api';
import { useImpState } from '../../app/hooks';
import { setMultiCardUser } from '../../app/loginSlice';
import { SCREEN, setScreen } from '../../app/screenStateSlice';
import { redirectTo } from '../../utils/functionUtils';
import { isSDK } from '../../utils/sdk';
import PINEntry from '../pinEntry/PINEntry';
import { VerifyDobPage } from '../pinEntry/VerifyDobPage';
import EarlyOtp from './EarlyOtp';

type PreSignupVerificationProps = {
  goToAccountStatus: () => void;
  goToManualApp: () => void;
};

export default function PreSignupVerification({
  goToAccountStatus,
  goToManualApp,
}: PreSignupVerificationProps) {
  const { loginState, dispatch } = useImpState();

  useEffect(() => {
    switch (loginState.nextStep) {
      case 'showSignUp':
        if (loginState.checkoutAppState) {
          // New user with existing application
          dispatch(callPrompt());
        }
        break;
      case 'verifyPIN':
        // Existing account
        dispatch(setMultiCardUser(true));
        break;
      case 'verifyPII':
        // Existing account but without a PIN
        if (isSDK()) {
          if (loginState.checkoutAppState === 'PREAPPROVED') {
            dispatch(setScreen(SCREEN.APPLICATION_OFFER_NOT_ACCEPTED));
          } else if (loginState.checkoutAppState === 'APPROVED') {
            dispatch(setScreen(SCREEN.APPLICATION_ACTIVE_USER));
          } else {
            dispatch(setScreen(SCREEN.FIND_ACCOUNT_REQUIRED));
          }
          goToAccountStatus();
        } else {
          redirectTo('account', false, false, true);
        }
        break;
      default:
        return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState]);

  switch (loginState.nextStep) {
    case 'verifyOTP':
    case 'showSignUp':
      return <EarlyOtp goToManualApp={goToManualApp} />;
    case 'verifyPIN':
      return <PINEntry />;
    case 'verifyDOB':
      return <VerifyDobPage />;
    case 'setPIN':
      return <PINEntry newPin />;
    case 'verifyPII':
      return (
        <ImpPad padding="120px">
          <ImpSpinner />
        </ImpPad>
      );
  }
}
